import { render } from "./UsageReport.vue?vue&type=template&id=456d9ad5"
import script from "./UsageReport.vue?vue&type=script&lang=js"
export * from "./UsageReport.vue?vue&type=script&lang=js"

import exportComponent from "/codebuild/output/src3444732531/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__